export default "__VITE_ASSET__fK$OeUaQ__"